// 字典表申请单状态

const Status = {
  ZT01: 'ZT01', // 已提交
  ZT02: 'ZT02', // 审批中
  ZT03: 'ZT03', // 已生效
  ZT04: 'ZT04', // 已禁用
  ZT05: 'ZT05', // 已驳回
  ZT06: 'ZT06', // 草稿
};

export default Status;
